import { Storage } from '@24i/nxg-sdk-quantum';
import { NAVIGATION_TARGET_REDIRECT_PAGE } from './constants';

export const saveTargetRedirectPage = (params: string): Promise<unknown> =>
    Storage.setItem(NAVIGATION_TARGET_REDIRECT_PAGE, params);

export const removeTargetRedirectPage = (): Promise<unknown> =>
    Storage.removeItem(NAVIGATION_TARGET_REDIRECT_PAGE);

export const getTargetRedirectPage = (): Promise<string> =>
    Storage.getItem(NAVIGATION_TARGET_REDIRECT_PAGE);
